import { useToastManager } from "@porsche-design-system/components-react"
import type { ExteriorColorView } from "@slfinrtl/ui-bff-routes"
import { useContext, useState } from "react"
import { defineMessages, useIntl } from "react-intl"
import { commonMessages } from "src/common/messages/common.messages"
import { Modal } from "src/context/modal/Modal"
import { ModalContext } from "src/context/modal/ModalContext"
import type { ModalProps } from "src/context/modal/ModalProvider"
import type { OrderType } from "../OrderType"
import { SelectCatalogExteriorColorContainer } from "./catalog/SelectCatalogExteriorColorContainer"
import { CustomExteriorColorContainer } from "./custom/CustomExteriorColorContainer"

const messages = defineMessages({
	selectExteriorColor: {
		defaultMessage: "Select exterior color",
		id: "colors.exteriorColor.selectExteriorColor",
	},
})

export interface SelectExteriorColorModalProps {
	exteriorColor: ExteriorColorView | undefined
	inventoryId: string
	orderType: OrderType
	setExteriorColor: (exteriorColor: ExteriorColorView) => void
}

type ExteriorColorModalState = "catalog" | "custom"

export const SelectExteriorColorModal = ({
	id,
	modalProps: { exteriorColor, inventoryId, orderType, setExteriorColor },
}: ModalProps<SelectExteriorColorModalProps>) => {
	const { formatMessage } = useIntl()
	const { hideModal } = useContext(ModalContext)
	const [state, setState] = useState<ExteriorColorModalState>(
		!exteriorColor || exteriorColor.optionCode ? "catalog" : "custom",
	)
	const { addMessage } = useToastManager()
	return (
		<Modal id={id} width="wide" heading={formatMessage(messages.selectExteriorColor)}>
			{state === "catalog" ? (
				<SelectCatalogExteriorColorContainer
					orderType={orderType}
					inventoryId={inventoryId}
					currentExteriorColor={exteriorColor}
					onExteriorColorSelected={(selectedExteriorColor) => {
						hideModal(id)
						setExteriorColor(selectedExteriorColor)
						addMessage({
							state: "success",
							text: formatMessage(commonMessages.saveSuccess),
						})
					}}
					showCustomExteriorColorContainer={() => setState("custom")}
				/>
			) : (
				<CustomExteriorColorContainer
					inventoryId={inventoryId}
					currentExteriorColor={exteriorColor}
					onExteriorColorCreated={(createdExteriorColor) => {
						hideModal(id)
						setExteriorColor(createdExteriorColor)
						addMessage({
							state: "success",
							text: formatMessage(commonMessages.saveSuccess),
						})
					}}
					showCatalogExteriorColorContainer={() => setState("catalog")}
				/>
			)}
		</Modal>
	)
}
